import {WwsUmsatzstatistikOptionenListStore} from './abstractions/optionen-list.store';
import { Belegart } from '../types/belegart';

export const WwsUmsatzstatistikBelegartStore = new WwsUmsatzstatistikOptionenListStore<Belegart>()
